const isHuaXiaoZhu = location.href.includes('hongyibo');

const DIDI = {
  omegaAppKey: 'omegac49da8cb34',
  apolloSDK: '//img-ys011.didistatic.com/static/apollo_js/apollo.min.js',
};

const BWH = {
  omegaAppKey: 'omega71083af484',
  apolloSDK: '//gift-static.hongyibo.com.cn/static/apollo_js/apollo.kflower.min.js',
};

/* eslint-disable no-param-reassign */
(function (window) {
  const qianfanEnvInfo = isHuaXiaoZhu ? BWH : DIDI;
  window.omegaAppKey = qianfanEnvInfo.omegaAppKey;

  const script = document.createElement('script');
  script.crossorigin = 'anonymous';
  script.src = qianfanEnvInfo.apolloSDK;
  document.getElementsByTagName('head')[0].appendChild(script);
}(window));
